import { theme as defaultTheme } from 'jpi-cloud-web-ui-kit';
import { DEFAULT_BRAND } from '../../config/common';
const SPACING = 8;

const theme = {
  ...defaultTheme,
  name: DEFAULT_BRAND,
  COLORS: {
    ...defaultTheme.COLORS,
    warning: '#EEAB46', //'#FF5722',
    info: '#1A237E',
    text: {
      ...defaultTheme.COLORS.text,
      muted: '#585858',
      primaryContrast: '#ffffff',
      warning: '#F25220', // it will change after UI updates
      dark: '#333',
      light: '#7a7a85',
      collapsedDescription: '#282834',
    },
    background: {
      ...defaultTheme.COLORS.background,
      table: '#f7f7f7',
      box: '#f4f9ff',
      button: '#318245',
      buttonLight: '#62b67e',
      card: '#f4f9ff',
      success: '#008554',
      error: '#A90000',
      warning: '#F4B24E',
      line: '#BFBFBF',
    },
    border: {
      main: '#ddd',
    },
    shadow: {
      lighter: '#0000000D',
      light: '#0000001A',
      medium: '#0000004D',
    },
    chart: {
      default: '#828282',
      success: ' #3A9A35',
      error: ' #a81524',
      warning: ' #F4B24E',
      info: ' #4689ee',
      fade: {
        success: '#75B871',
        error: '#C25B66',
        warning: '#F3C47E',
        info: '#7EACF3',
        default: '#a1a1a1ff',
      },
    },
    scheduling: {
      color: {
        default: '#414042',
        hover: '#000',
        setting: '#5d5d5d',
      },
      background: {
        selected: '#828282',
        timeSlots: '#c4c4c4',
      },
    },
    pagination: {
      default: '#c8c8c8',
      selected: '#1a227e',
    },
    devices: {
      color: '#414042',
      info: '#7d7c7c',
      status: {
        available: '#f25220',
        updated: '#00963f',
      },
    },
    integrationSteps: {
      background: '#1a237e',
    },
    link: {
      info: '#337ab7',
    },
    fontColor: '#414042',

    spacing: (...args) => `${args.map(_ => _ * SPACING).join('px ')}px`,

    defaultBrand: '#1A237E',
  },
};

export default theme;
